import React from 'react'
import XRayDrawer from '../../components/drawers/dentalXray'
import BilledQueue from '../../components/pages/billedQueue'

const XRay = () => {
    return (
        <BilledQueue
            category="Dental-XRay"
            basePath="/app/dental/x-ray"
            DrawerComponent={XRayDrawer}
            forwardSource="Dental-XRay"
            requestDepartment="Dental-XRay"
        />
    )
}

export default XRay
